<template>

    <div class="content-load">

        <Top></Top>
        <!-- Dashboard Container -->
        <div class="dashboard-container">

            <Sidebar></Sidebar>

            <!-- Dashboard Content
            ================================================== -->
            <div class="dashboard-content-container">
                <div class="dashboard-content-inner" >

                    <!-- Dashboard Headline -->
                    <div class="dashboard-headline hidden-xs">
                        <h3>{{$router.currentRoute.meta.title}}</h3>
                    </div>
                      

                    <!-- Row -->
                    <div class="row">
                        <form method="post" v-on:submit.prevent="submit" novalidate="" autocomplete="off">

                            <!-- Dashboard Box -->
                            <div class="col-xl-12">
                                <div class="dashboard-box margin-top-0">

                                    <!-- Headline -->
                                    <div class="headline">
                                        <h3><i class="material-icons">info</i> Informações gerais</h3>
                                    </div>

                                    <div class="content with-padding padding-bottom-0">

                                        <div class="row">

                                            <div class="col-xl-6 col-md-9 col-lg-9">
                                                <div class="submit-field">
                                                    <h5>Título:</h5>
                                                    <input type="text" class="with-border" placeholder="..." v-model="form.objeto.titulo">
                                                </div>
                                            </div>

                                            <div class="col-xl-12 margin-bottom-15">
                                                <div class="submit-field">
                                                    <h5>Conteúdo da dica:</h5>
                                                    <trumbowyg v-model="form.objeto.texto" :config="config" class="" name="conteudo"></trumbowyg>
                                                </div>
                                            </div>

                                            <div class="col-xl-12 col-xs-12 col-md-12 col-lg-12">
                                                <div class="submit-field">
                                                    <h5>Imagem de capa: <small>(opcional)</small></h5>
                                                        

                                                    <div class="uploadButton ">
                                                        <input class="uploadButton-input" type="file" name="aruivo" :id="'upload-arquivo-' + '1'" @change="getBase64Arquivo" accept="image/*" />
                                                        <label class="uploadButton-button color-primary" :for="'upload-arquivo-' + '1'">
                                                            <i class="material-icons">attach_file</i>
                                                            Enviar arquivo
                                                        </label>
                                                        <!-- <span class="uploadButton-file-name" style="height: 20px; overflow: hidden; display: block; white-space: nowrap; text-overflow: ellipsis;">{{arquivoNome}}</span> -->
                                                    </div>              
                                               
                                                    <img :src="form.arquivo.indexOf('uploads') != -1 ? ($root.config.url + '/' + form.arquivo) : form.arquivo" v-if="form.arquivo" style="width: 100%; margin-top: 0px; margin-bottom: 20px; max-width: 400px;">
                                               
                                                </div>
                                            </div>    

                                            <div class="col-xl-6 col-md-9 col-lg-9 margin-top-20">
                                                <div class="submit-field">
                                                    <h5>Enviar notificação push com a dica?</h5>
                                                    <div class="checkbox">
                                                        <input type="checkbox" id="enviar-push" v-model="form.objeto.pushEnviar" true-value="1" false-value="0">
                                                        <label for="enviar-push"><span class="checkbox-icon"></span> Sim, enviar</label>
                                                    </div>                                            
                                                </div>
                                            </div>
        
                                            <div class="col-xl-12 clearfix"></div>

                                            <div class="col-xl-6 col-md-9 col-lg-9 margin-top-10" v-show="form.objeto.pushEnviar == 1">
                                                <div class="submit-field">
                                                    <h5>Título notificação push:</h5>
                                                    <input type="text" class="with-border" placeholder="..." v-model="form.objeto.pushTitulo">
                                                </div>
                                            </div>
                                            <div class="col-xl-12 clearfix"></div>

                                            <div class="col-xl-12 col-md-12 col-lg-12 col-xs-12" v-show="form.objeto.pushEnviar == 1">
                                                <div class="submit-field">
                                                    <h5>Texto notificação push:</h5>
                                                    <textarea placeholder="..." class="with-border" v-model="form.objeto.pushTexto" style="min-height: 80px;"></textarea>
                                                </div>
                                            </div>
                                            <div class="col-xl-12 clearfix margin-bottom-20" v-if="form.objeto.pushEnviar == 1">
                                                <hr>
                                            </div>

                                            <div class="col-xl-4 col-md-6 col-lg-5 col-xs-12 margin-top-10" v-show="form.objeto.pushEnviar == 1">
                                                <div class="submit-field">
                                                    <h5 class="margin-bottom-10">Deseja enviar agora ou agendar?</h5>
                                                    <div class="checkbox">
                                                        <input type="checkbox" id="enviar-agora" true-value="0" false-value="1" v-model="form.objeto.agendamento">
                                                        <label for="enviar-agora"><span class="checkbox-icon"></span> Enviar agora</label>
                                                    </div>
                                                </div>
                                            </div>                                
                                            <div class="col-xl-3 col-xs-8 col-md-6 col-lg-3" v-show="form.objeto.pushEnviar == 1 && form.objeto.agendamento == 1">
                                                <div class="hidden-xs hidden-xl hidden-md margin-top-10"></div>
                                                <div class="submit-field margin-bottom-0">
                                                    <h5>Data</h5>
                                                </div>
                                                <input type="date" class="with-border" data-placeholder="___ /____ /_____" v-model="form.objeto.data" required="">
                                            </div>     
                                            <div class="col-xl-2 col-xs-4 col-md-4 col-lg-3" v-show="form.objeto.pushEnviar == 1 && form.objeto.agendamento == 1">
                                                <div class="hidden-xs hidden-xl hidden-md margin-top-10"></div>
                                                <div class="submit-field margin-bottom-0">
                                                    <h5>Hora</h5>
                                                </div>
                                                <input type="time" class="with-border" data-placeholder="__ : __" v-model="form.objeto.hora" required="">
                                            </div>                                                                                   
                                      
                                            <div class="col-xl-12 clearfix"></div>

                                            <!-- Button -->
                                            <div class="col-xl-12 margin-bottom-30 margin-top-25">
                                                <button type="submit" class="button green block-mobile" v-bind:class="{'disabled': loading.submit }">
                                                    <i class="material-icons">save</i>
                                                    Salvar
                                                </button>
                                            </div>

                                        </div>
                                    </div>
                                </div>

                            </div>

                        </form>
                    </div>
                </div>
            </div>
        </div>
        <Toolbar></Toolbar>

    </div>
</template>

<script>
import Top from './Top'
import Toolbar from './Toolbar'
import Sidebar from './Sidebar'

export default {
    name: 'GerenciarPosts',
    components: {
        'Trumbowyg':                VueTrumbowyg.default,
        'Top':                      Top,
        'Sidebar':                  Sidebar,
        'Toolbar':                  Toolbar
    },       
    data () {
        var self                    = this;
        return {
            "arquivoNome":          "",
            config: {
                svgPath:            "https://cdnjs.cloudflare.com/ajax/libs/Trumbowyg/2.20.0/ui/icons.svg",
                btns: [
                    ['undo', 'redo'],
                    ['formatting'],
                    ['strong', 'em', 'del'],
                    ['link'],
                    ['insertImage'],
                    ['justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull'],
                    ['unorderedList', 'orderedList'],
                    ['horizontalRule'],
                    ['removeformat'],
                ]
            },          
            "loading": {
                "submit":           false
            },
            "empresas": {
                "itens":            []
            },
            "form": {
                "_cod":             "",
                "_token":           "",
                "nome":             "post",
                "arquivo":          null,
                "objeto": {
                    "pushEnviar":       0,
                    "pushTexto":        "",
                    "pushTitulo":       "",
                    "titulo":           "",
                    "agendamento":      0,
                    "conteudo":         "",
                    "data":             "",
                    "hora":             ""
                }
            }            
        }
    },
    methods: {
        getBase64Arquivo: function(event) {
            var self            = this;
            if (event.target.files[0]) {
                loading.show();
                reduceFileSize(event.target.files[0], 500*1024, 1000, Infinity, 0.9, blob => {
                    blobToBase64(blob, function(result) {
                        loading.hide();
                        self.form.arquivo   = result;
                        self.arquivoNome    = event.target.files[0].name;
                        self.$forceUpdate();
                    });
                }); 
            }   
        },            
        submit: function(e) {
            var self            = this;
            self.form._cod      = self.$root.user.cod;
            self.form._token    = self.$root.user.token;
            console.log("submit()", e, self.form, JSON.stringify(self.form));
            e.preventDefault();
            self.loading.submit = true;
            loading.show();
            axios.put("api/itens.php", self.form)
            .then(response => {
                
                self.loading.submit = false;
                console.log("submit() response", response)
                loading.hide();
                alert(response.data.message);
                self.$root.back();
                
            })
            .catch(error => {
                console.log("submit() error", error)
                loading.hide();
                self.loading.submit = false;
                alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
            });

        },
        get: function() {
            var self        = this;
            console.log("get()", self.form);
            loading.show();
            return new Promise(function(resolve, reject) {

                var form = {
                    "params": {
                        "_cod":         self.$root.user.cod, 
                        "_token":       self.$root.user.token,
                        "nome":         "post",
                        "cod":          self.form.cod
                    }
                };

                axios.get("api/itens.php", form)
                .then(response => {
                    
                    console.log("get() response", response);

                    self.form           = response.data.result;
                    loading.hide();
                    resolve(response.data.result);
  
                })
                .catch(error => {
                    console.log("get() error", error);                    
                    loading.hide();
                    reject(error);
                    alert((error.response ? error.response.data.message : "Por favor, verifique sua conexão e tente novamente mais tarde."));
                    if (error.response) {
                        if (error.response.status == 404) {
                            self.$root.back();
                        }
                    }                    
                });   
            });   
        }
    },    
    created: function() {
        var self = this;
        console.log("created", self);
        loading.hide();
        if (self.$route.name == "EditarPosts") {
            if (!self.$route.query.c) {
                self.$root.back();
                return false;
            }
            self.form.cod = self.$route.query.c;
            self.get();
        } else {
            loading.hide();
        }
    },
    mounted: function() {
    }     
} 
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/GerenciarPosts.vue